import * as React from "react";
import {cx} from "emotion";

import "./select-mailing-list-modal.scss";

import {getCountryCode}  from "@Common/logic/template-options/get-country-code";
import {cs}              from "@Common/react/chain-services";
import {UseState}        from "@Common/react/use-state";

import {isDevQuan}               from "../../../debug/is-dev-quan";
import {ModalService3}           from "../../../modal-service-3/modal-service-3";
import {DataTableD1}             from "../../common/design2/data-table/data-table-d1";
import {PageList}                from "../../common/design2/pagination-ui/page-list/page-list";
import {PageSize, PAGE_SIZE_ALL} from "../../common/design2/pagination-ui/page-size/page-size";
import {MLListTable}             from "../ml-list-table/ml-list-table";

export const SelectMailingListModal = ({mailingListIds, itemId=undefined, templateOptions=undefined, mailingLists=undefined, next: rootNext}) => cs(
    ["modal", ({}, next) => ModalService3({
        initShow: 0&&isDevQuan(),
        next: ({close}) => next({close}),
        rootNext,
    })],

    ["mailingTable", ({}, next) => MLListTable({
        itemId,
        mailingListIds,
        showHeaderSummary: false,
        showSource: false,

        countryCode: getCountryCode({templateOptions}),
        eddmUnavailable: !Object.keys(templateOptions?.mailingClasses??{}).find((mailingClassKey) => mailingClassKey === "3"),

        mailingLists,

        next,
    })],

    ({modal, mailingTable}) => (
        <div className="select-mailing-list-modal-1wi">
            <div className="header">
                <div className="title">
                    Edit Mailing List
                </div>

                {/* <div className="info">
                    Tap the button below to create a new mailing list.
                </div> */}

                <button
                    className="create-new"
                    onClick={() => mailingTable.showCreateMailingListModal()}
                    xd-qa-type="button" xd-qa-name="Create a New Mailing List"
                >
                    Create a New Mailing List
                </button>

            </div>

            <div className="content">

                {cs(
                    ["pageSize", (_, next) => UseState({next, getInitValue: () => 10})],
                    ({pageSize}) => DataTableD1({
                        getDefaultSorting: () => ({
                            columnIndex: 3, // Order by newest date created
                            direction: "desc",
                        }),
                        className: cx("table", mailingTable.className),
                        paginationKey: mailingTable.selectedOnly.value,
                        columns: mailingTable.columns,
                        rows: mailingTable.rows,
                        emptyAction: mailingTable.emptyAction,
                        pageSize: pageSize.value,
                        getExtraRows: ({pagination, colCount}) => [
                            ...mailingTable.rows.length <= 10 ? [] : [{
                                className: "paging-control",
                                color: "light",
                                columns: [{
                                    colSpan: colCount,
                                    render: () => (
                                        <div className="controls">
                                            {PageSize({
                                                state: pageSize,
                                                extraSizes: [PAGE_SIZE_ALL],
                                            })}

                                            {pagination.active && (
                                                <div className="pagination">
                                                    {PageList(pagination)}
                                                </div>
                                            )}
                                        </div>
                                    ),
                                }],
                            }],
                            // ...getExtraRows({colCount}),
                        ],
                    }),
                )}

                
            </div>

            <div className="footer">
                <button
                    className="yes"
                    onClick={() => {
                        modal.close();
                    }}
                    xd-qa-type="button"
                    xd-qa-name="Save & Continue"
                >
                    Save & Continue
                </button>

                
            </div>
        </div>
    )
);
